import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderMenuComponent } from './header-menu.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule
  ],
  declarations: [HeaderMenuComponent],
  exports: [HeaderMenuComponent]
})
export class HeaderMenuModule { }
